import GenerationFinish from './GenerationFinish'

export default GenerationFinish
